import { useMutation } from "@apollo/client";

import { PauseRecurringDepositMutation, PauseRecurringDepositMutationVariables } from "@ctypes";
import { PAUSE_SIP } from "@graphql";

export const usePauseSip = () => {
  return useMutation<PauseRecurringDepositMutation, PauseRecurringDepositMutationVariables>(
    PAUSE_SIP,
  );
};
